import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import {
  getDataDownloadSettings,
  IDataDownloadSettingsDTO,
  saveDataDownloadSettings,
} from 'wisestep-api';
import {
  ControlledTextInput,
  Label,
  WsButton,
  WsInputNumber,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { warning, success } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import { HeaderBox } from '../../../jobSettings/components/HeaderBox';
import { defValues } from '../downloadSettings/helper';

const StyledLabel = styled(Label)(() => ({
  fontWeight: 'bold',
  minWidth: '351pt',
  lineHeight: '32pt',
}));
const Limitation = () => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [dataDownloadSettingsData, setDataDownloadSettingsData] =
    useState<IDataDownloadSettingsDTO>(defValues);

  useEffect(() => {
    const fetchDataDownloadSettings = async () => {
      try {
        const getDataDownloadSettingsRes = await getDataDownloadSettings();
        setDataDownloadSettingsData(getDataDownloadSettingsRes.data);
      } catch (e) {
        console.log(e);
      }
    };
    fetchDataDownloadSettings();
  }, []);

  const methods = useForm();
  useEffect(
    () =>
      methods.reset({
        records: dataDownloadSettingsData.recordsDownloadLimit,
        email: dataDownloadSettingsData.downloadCcEmail,
      }),
    [dataDownloadSettingsData, methods]
  );

  const { handleSubmit } = methods;
  const onSaveHandler = async (data: FieldValues) => {
    try {
      if (dataDownloadSettingsData && data) {
        const tempData: IDataDownloadSettingsDTO = dataDownloadSettingsData;
        if (dataDownloadSettingsData.workspaceId === 'DEFAULT') {
          delete dataDownloadSettingsData.id;
          delete dataDownloadSettingsData.workspaceId;
        }
        if (data.records > 10000) {
          setNotification(warning('Download limit should not be more than 10000'));
          return;
        }
        tempData.recordsDownloadLimit = data.records ?? 2000;
        tempData.downloadCcEmail = data.email ?? '';
        await saveDataDownloadSettings(tempData);
        setNotification(success('Attributes settings applied successfully'));
      }
    } catch (error) {
      setNotification(warning('Something Went Wrong , Please try again'));
    }
  };
  return (
    <FormProvider {...methods}>
      <HeaderBox mb={4}>
        <WsTypography variant={WsTypoVariants.SUB_TITLE}>
          Download Limit and Email Notification
        </WsTypography>
        <WsButton type="submit" onClick={handleSubmit(onSaveHandler)} size="small">
          Save
        </WsButton>
      </HeaderBox>
      <Grid container rowSpacing={2}>
        <Grid item sm={12} display="flex" direction="row" justifyContent="space-between">
          <StyledLabel>Limit the number of download records</StyledLabel>
          <WsInputNumber maxValue={10000} name="records" label="Default Value 2000, Max 10000 " />
        </Grid>

        <Grid item sm={12} display="flex" direction="row" justifyContent="space-between">
          <StyledLabel>Notify this email address when data is downloaded</StyledLabel>
          <ControlledTextInput placeholder="E-mail Address" name="email" variant="outlined" />
        </Grid>

        <Grid item mt={5}>
          <WsTypography variant={WsTypoVariants.BODY2}>
            Once you save your Settings, Refresh the page you are Downloading Data from.
          </WsTypography>
        </Grid>
      </Grid>
    </FormProvider>
  );
};

export default Limitation;
